export default __webpack_public_path__ + "static/media/lat.7b7e979c.svg";